module.exports = __webpack_public_path__ + "img/cgd6.be30113a.jpg";